import ChatThreadExchangeRow from '@/components/Chat/ChatThreadView/ChatThreadExchangeRow'
import { useThreadsSearchDialogPreviewThread } from './useThreadsSearchDialogPreviewThread'

export default function ThreadsSearchDialogPreviewRows({ messages, threadId }) {
  const vm = useThreadsSearchDialogPreviewThread(messages, threadId)
  return vm.exchanges.map((exchange, exchangeIndex) => (
    <ChatThreadExchangeRow
      key={exchange.exchangeId}
      exchange={exchange}
      exchangeIndex={exchangeIndex}
      exchanges={vm.exchanges}
      getExchangeDisplayUser={vm.getExchangeDisplayUser}
      calendarNow={vm.calendarNow}
      edit={vm.edit}
      preamble={vm.preamble}
      startSpeech={vm.startSpeech}
      activeThreadId={threadId}
      activeQueryVersionByExchangeId={{}}
      activeAnswerVersionByExchangeId={{}}
    />
  ))
}
